import React from "react";

import UsersDataTable from "./UsersDataTable";

const UsersPage = () => {
  return (
    <div className="sub-content">
      <UsersDataTable />
    </div>
  );
};

export default UsersPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/users/UsersPage.js